import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PicturesPage } from '../pictures/pictures.page';
import { CropperComponent } from 'angular-cropperjs';
import { GenericChoicePage } from '../generic-choice/generic-choice.page';
import { AlertController, ModalController, NavParams, ToastController, Platform, ActionSheetController, ItemReorderEventDetail } from '@ionic/angular';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoadingController } from '@ionic/angular';
import { Preferences } from '@capacitor/preferences';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';
import { EmailValidationPage } from '../email-validation/email-validation.page';
import { GenericInputPage } from '../generic-input/generic-input.page';
import { InterestPage } from '../interest/interest.page';
import { HeightPage } from '../height/height.page';
import { LookingForPage } from '../looking-for/looking-for.page';
import { SocialCausesPage } from '../social-causes/social-causes.page';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { LocationService } from '@shared/services/location.service';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { Camera, CameraResultType, CameraSource, Photo, } from '@capacitor/camera';
import { ReferralConfirmationPage } from '../referral-confirmation/referral-confirmation.page';
import { PurchaseService } from 'src/app/services/purchase.service';
import { StoreV2Page } from '../store-v2/store-v2.page';
import { ActivatedRoute, Router } from '@angular/router';
import 'hammerjs';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';
import { ValidationCompletedComponent } from '@shared/components/validation-completed/validation-completed.component';
import { NewPhotoNotApprovedComponent } from '@shared/components/new-photo-not-approved/new-photo-not-approved.component';
import { NewPhotoValidationComponent } from '@shared/components/new-photo-validation/new-photo-validation.component';
import { ProfileAlreadyValidatedComponent } from '@shared/components/profile-already-validated/profile-already-validated.component';
import { Capacitor } from '@capacitor/core';
import { NotAvailableComponent } from '@shared/components/not-available/not-available.component';
import { SocialCausesService } from '@shared/services/social-causes.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
  providers: [UserService, UtilService, NavParams]
})
export class ProfilePage implements OnInit {
  @ViewChild('angularCropper')
  public angularCropper: CropperComponent = new CropperComponent;
  cropperOptions: any;
  croppedImage: any = null;
  showCropper: boolean = false;
  private denyCount = 0;

  // Detecção de iPad/Tablet
  public isIpad: boolean = false;
  public isTablet: boolean = false;

  myImage: any = null;
  scaleValX = 1;
  scaleValY = 1;

  private loader = this.loadingCtrl.create({
    message: this.translate.instant('msgOneMomentPlease'),
  });

  // Profile Image Related
  public shuffling: boolean = false;
  public grayPlus: string = PicturesPage.grayPlus;
  public pictures: string[] = Array(9).fill(PicturesPage.grayPlus);
  private preShufflePictures: string[] = [];
  private picChanged: boolean[] = [false, false, false, false, false, false, false, false, false];

  private isNative: boolean = true;
  private workingOnIndex: number = 0;
  private index: number | undefined;



  public myForm: any;
  submitAttempt: boolean = false;
  public userData: any;
  public isFirstSetup: boolean = false;
  private changed: boolean = false;
  private theNameControl: FormControl =
    new FormControl('', Validators.compose([Validators.required, Validators.maxLength(100), Validators.minLength(2)]));
  private theGenderControl: FormControl = new FormControl('', Validators.required);
  private theInterestControl: FormControl = new FormControl('', Validators.required);

  private theSinceControl: FormControl = new FormControl('');
  private theAgeControl: FormControl =
    new FormControl('', Validators.compose([Validators.required, Validators.min(18), Validators.max(100)]));
  private cityControl: FormControl = new FormControl('', Validators.maxLength(50));
  private theAboutControl: FormControl = new FormControl('', Validators.maxLength(1000));
  private theWorkControl: FormControl = new FormControl('', Validators.maxLength(100));
  private theLanguageControl: FormControl = new FormControl('', Validators.required);
  private theDistanceUnitControl: FormControl = new FormControl('', Validators.required);
  private referralEmailControl: FormControl = new FormControl('', Validators.maxLength(50));
  private limitDate = new Date();
  public aboutData: string = "";
  private today = this.limitDate.getFullYear + '-' + this.limitDate.getMonth() + '-' + this.limitDate.getDay();
  public date = new Date();
  public now: any = this.date.toISOString().slice(0, 10);
  
  protected dietSinceDate: Date = new Date();
  protected openDatePicker: boolean = false;
  protected fromDate = "1950-01-01";


  public charsRemainingInput: number = 1000;

  public showAvocadoClubIndicator: boolean = false;
  public userIsPremium: boolean = false;

  public imageTest: string = ""

  public missingInformation: boolean = false;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    public navParams: NavParams,
    public userService: UserService,
    public util: UtilService,
    public toastCtrl: ToastController,
    private alertCtrl: AlertController,
    public locationSvc: LocationService,
    private sanitizer: DomSanitizer,
    private platform: Platform,
    public actionSheetCtrl: ActionSheetController,
    private analytics: AnalyticsService,
    private purchaseServiceProvider: PurchaseService,
    private socialCausesService: SocialCausesService,
  ) {

    // this.translate.setDefaultLang('pt');
    this.util.initTranslate();

    this.showAvocadoClubIndicator = this.navParams.get("showAvocadoClubIndicator");

    this.myForm = new FormGroup({
      nameControl: this.theNameControl,
      genderControl: this.theGenderControl,
      interestControl: this.theInterestControl,

      sinceControl: this.theSinceControl,
      ageControl: this.theAgeControl,
      cityControl: this.cityControl,
      aboutControl: this.theAboutControl,
      workControl: this.theWorkControl,
      languageControl: this.theLanguageControl,
      distanceUnitControl: this.theDistanceUnitControl,
      referralEmailControl: this.referralEmailControl
    });

    this.setupPictures();

    this.loadView(true);
  }

  ngOnInit(): void {
    // Detecção de iPad/Tablet
    this.isIpad = this.platform.is('ipad') || (this.platform.is('ios') && window.innerWidth >= 768);
    this.isTablet = this.isIpad || (this.platform.is('android') && window.innerWidth >= 768);
    
    // Debug para verificar detecção
    console.log('iPad detected:', this.isIpad);
    console.log('Tablet detected:', this.isTablet);
    console.log('Window width:', window.innerWidth);
    console.log('Platform:', this.platform.platforms());
  }



  private setupPictures() {
    this.cropperOptions = {
      viewMode: 1,
      dragMode: 'crop',
      aspectRatio: 1, // Define a proporção desejada para o crop
      minCroppedWidth: 320,
      autoCrop: true,
      movable: true,
      zoomable: true,
      scalable: true,
      autoCropArea: 0.8
      //,height: 200
    };

    Preferences.get({ key: 'USER_DATA' }).then((val) => {
      this.userData = val.value ? JSON.parse(val.value) : null;
      this.loadImages();
    });


    this.isNative = this.util.isNative();
  }

  private loadImages() {
    var i;
    for (i = 0; i < this.pictures.length; i++) {
      const aPic: string = 'picture' + i;
      const aPicValue = this.userData[aPic];
      if (aPicValue != undefined && aPicValue != null) {
        let imgUrl = this.userService.getImageURL(aPicValue.$oid); //this.soulService.getBaseURL() + '/soul/image/' + aSoul[aPic].$oid; // Set the URL here as last resort
        console.log('imgUrl: ' + imgUrl);
        this.pictures[i] = imgUrl;

      }
    }

  }







  private loadView(isFirstTime: boolean) {
    Preferences.get({ key: 'USER_DATA' }).then((val) => {
      this.userData = val.value ? JSON.parse(val.value) : null;

      if (val === null) {
        this.router.navigateByUrl('/login');
      }

      console.log('profile - this.userData: ' + JSON.stringify(this.userData));

      this.isFirstSetup = this.userData.interest == null && this.userData.interest2 == null;

      if (this.userData.language == null) {
        let browserLang = this.translate.getBrowserLang();
        if (browserLang == null) {
          browserLang = 'en';
        }
        this.userData.language = browserLang;
      }
      // Set default distanceUnit if not yet set (firt time setup only)
      if (this.userData.distanceUnit == null) {
        if (this.userData.language == 'en') {
          this.userData.distanceUnit = 'mi';
        } else {
          this.userData.distanceUnit = 'km';
        }

      }


      if (this.userData.since != null) {


      }
      //      console.log('profile - this.userData: ' + JSON.stringify(this.userData));
      console.log('profile - this.userData.gender: ' + this.userData.gender);


      if (this.userData.age != null) {
        this.myForm.controls['ageControl'].setValue(this.userData.age);
      } else {
        if (this.userData.birth != null) {
          //          let calcAge = this.calculateAge(new Date('08/01/1979'));
          // TODO test it's working when birth is coming from Facebook
          console.log('profile - this.userData.birth: ' + this.userData.birth);
          let calcAge = this.userService.calculateAge(new Date(this.userData.birth));
          this.myForm.controls['ageControl'].setValue(calcAge);

        }

      }


      if (this.userData.about != null) {
        this.aboutData = this.userData.about;
        // this.adjust();
      }

      this.submitAttempt = false;
    })
  }

  async backPage() {

    await this.savePicturesOnUserData(this.pictures);
    if (!this.userService.checkUserHasPicture(this.userData)) {
      this.showModalAlertSavingProfileWithoutPicture()
    } else {
      await this.save();
      if (window.location.href.indexOf(`https://web.flamr.app/?referralUserId=`) === 0) {
        this.openModalDownloadApp()
      } else {
        let loader = this.loadingCtrl.create({
          message: this.translate.instant('pleaseWait'),
        });
        (await loader).present();
        setTimeout(async () => {
          (await loader).dismiss();
          this.modalCtrl.dismiss();

        }, 1000);
      }
    }
  }

  async showModalAlertSavingProfileWithoutPicture() {
    let alert = this.alertCtrl.create({
      subHeader: this.translate.instant('yourProfileWontBeShownUnlessYouUploadOnePicture'),
      buttons: [{
        text: this.translate.instant('saveAndExit'),
        handler: async () => {
          console.log('save and exit clicked');
          this.missingInformation = this.userData.gender2 == null || this.userData.interest2 == null
            || this.userData.firstName == null || this.userData.age == null || this.userData.city == null;
          if (this.missingInformation) {
            this.alertMissingInformation();
            return;
          }
          await this.save();
          if (window.location.href.indexOf(`https://web.flamr.app/?referralUserId=`) === 0) {
            this.openModalDownloadApp()
          } else {
            setTimeout(() => {
              // this.router.navigateByUrl('/tabs/home', { skipLocationChange: true }).then(() => {
              //   this.router.navigate(['/tabs/my-profile-display']);
              // });
              this.modalCtrl.dismiss();
            }, 1000);
          }
          return;
        }
      },
      {
        text: this.translate.instant("uploadNow"),
        handler: () => {
          console.log('upload now clicked');
          return;
        }
      }
      ]

    });

    (await alert).present();
  }

  async openModalDownloadApp() {
    let modal = this.modalCtrl.create({ component: ReferralConfirmationPage });
    (await modal).onDidDismiss().then((val) => {

      setTimeout(() => {
        this.modalCtrl.dismiss();
      }, 1000);


      if (val && val.data === "logout") {
        this.router.navigateByUrl('/login');
        return;
      }

    });

    (await modal).present();
  }


  async save() {
    this.submitAttempt = true;

    await this.savePicturesOnUserData(this.pictures);

    await this.saveLocally();

    /*
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('pleaseWait'),
    });
    loader.present();*/

    var theObs: Observable<any>;

    await Preferences.get({ key: 'LAST_LOCATION' }).then(async (val) => {
      val = val.value ? JSON.parse(val.value) : null;
      let location = val;
      let teleportationLocation = this.locationSvc.getTeleportationLocation();
      if (teleportationLocation != null) {
        location = teleportationLocation;
      }

      this.userData.showAvocadoClubIndicator = this.showAvocadoClubIndicator;
      console.log('userdata before upsert: ', this.userData);

      theObs = await this.userService.upsertSoul(this.userData, location, false, false, false)

      theObs.subscribe(async data => {
        console.log('profile - upsert subscribe entered');
        console.log(JSON.stringify(data));


        if (data != '{not ok}') {
          var userData = JSON.parse(data);
          console.log(userData.showAvocadoClubIndicator);
          await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(userData) }).then((val) => {
            console.log('userdata saved to DB');
          })


          this.changed = false;
          //loader.dismiss();
          if (this.isFirstSetup && userData.receivedReferralCoin) {
            let alert = this.alertCtrl.create({
              message: this.translate.instant('congratsYouAndFriendReceivedCoin'),
              buttons: [
                {
                  text: 'OK',
                  role: 'cancel',
                  handler: () => {
                    //this.editPictures();
                  }
                }
              ]
            });
            (await alert).present();

          }

          if (this.isFirstSetup) {
            this.analytics.registerEvent(AnalyticsService.signUpEvent);
            if (this.userService.checkUserHasPicture(userData)) {
              this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
              this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
            }
          }

          this.isFirstSetup = false;
        } else {
          //loader.dismiss();
        }



      },
        err => {
          this.util.showToastUnableToConnect(this.toastCtrl);
          console.log('Error: ' + JSON.stringify(err));
          //alert('Invalid email or password. Please, try again');
          // loader.dismiss();
        })
    });




  }

  private saveLocally() {
    if (this.isFirstSetup) {
      this.userData.coins = 1;
      this.userData.receivedCoins = true;
    }
    if (this.userData.age != null && typeof this.userData.age == "string") {
      this.userData.age = parseInt(this.userData.age);
    }
    this.userData.about = this.aboutData;

    Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((val) => {
      console.log('userdata saved to DB');
    });
  }

  setShowAvocadoClubIndicator() {
    this.showAvocadoClubIndicator = !this.showAvocadoClubIndicator;
  }

  async goToAvocadoClubIndicator() {
    this.showModalAlertNeedToHaveAvocadoClub()
  }

  async showModalAlertNeedToHaveAvocadoClub() {
    let alert = this.alertCtrl.create({
      subHeader: this.translate.instant('joinClubAndShowInYourProfile'),
      buttons: [{
        text: this.translate.instant('cancel'),
        handler: () => {
          console.log('cancel clicked');
          return;
        }
      },
      {
        text: this.translate.instant('joinClub'),
        handler: async () => {
          console.log('Join club clicked');
          this.analytics.registerEvent(AnalyticsService.avocado);
          this.analytics.registerEvent(AnalyticsService.avcdFromIndicator);
          let modal = this.modalCtrl.create({ component: StoreV2Page, componentProps: { me: this.userData, type: 'avocado_club', from: "joinClub" }, showBackdrop: true, backdropDismiss: true });
          (await modal).present();
          (await modal).onDidDismiss().then((val) => {
            this.userIsPremium = this.purchaseServiceProvider.isPremium(this.userData);
            if (this.userIsPremium) {
              this.showAvocadoClubIndicator = true;
              Preferences.set({ key: 'showedAvocadoClubPopup', value: JSON.stringify(true) }).then((val) => {
                console.log('showedAvocadoClubPopup saved to DB');
              });
            }
          });

          return;
        }
      }
      ]

    });

    (await alert).present();
  }

  setChanged() {
    this.changed = true;
    console.log('setChanged called..');
  }





  getCharsLeft() {
    return this.charsRemainingInput - this.aboutData.length;
  }

  getCharStatus() {
    if (this.getCharsLeft() <= this.charsRemainingInput && this.getCharsLeft() >= 10) {
      return " full";

    } else if (this.getCharsLeft() < 10 && this.getCharsLeft() > 0) {
      return " filling";

    } else if (this.getCharsLeft() == 0) {
      return " empty";

    } else {
      return " negative"
    }
  }

  setModals(pageName: string, isGeneric: boolean, genericType: string, pageInfo: any) {
    // console.log(isGeneric);
    // console.log(pageInfo);
    console.log(this.userData);

    // return this.modalCtrl.create({component: GenericChoicePage, componentProps: { theSoul: this.userData, pageParameters: pageInfo }});
    //checks if the modal's generic or not
    switch (isGeneric) {
      case true:
        if (genericType == 'choice') {
          return this.modalCtrl.create({ component: GenericChoicePage, componentProps: { theSoul: this.userData, pageParameters: pageInfo } });

        } else {
          return this.modalCtrl.create({ component: GenericInputPage, componentProps: { theSoul: this.userData, pageParameters: pageInfo } });
          // return this.modalCtrl.create(GenericInputPage, { theSoul: this.userData, pageParameters: pageInfo });

        }

      //if not, it sets them manually
      case false:
        switch (pageName) {
          case 'interest':
            return this.modalCtrl.create({ component: InterestPage, componentProps: { theSoul: this.userData, firstSetup: this.isFirstSetup } });
            // return this.modalCtrl.create(InterestPage, { theSoul: this.userData, firstSetup: this.isFirstSetup });
            return
          case 'height':
            return this.modalCtrl.create({ component: HeightPage, componentProps: { theSoul: this.userData, firstSetup: this.isFirstSetup } });
            // return this.modalCtrl.create(HeightPage, { theSoul: this.userData });
            return
          case 'lookingFor':
            return this.modalCtrl.create({ component: LookingForPage, componentProps: { theSoul: this.userData } });
            // return this.modalCtrl.create(LookingForPage, { theSoul: this.userData });
            return
          case 'socialCauses':
            return this.modalCtrl.create({ component: SocialCausesPage, componentProps: { theSoul: this.userData, firstSetup: this.isFirstSetup } });
            return
        }


    }
    return

  }

  protected activeFocus: boolean = true;

  //sets profile view status
  setActiveFocus(focus: boolean) {
    this.activeFocus = focus;

  }

  setPageInfo(page: string | null) {
    console.log("userData: ", this.userData);

    interface GenericChoiceInterface {
      logoURL: string,
      text: string,
      options: { value: any, label: string }[],
      fieldName: string,
      selectMultipleAllowed: boolean,
      previousPage: string | any,
      nextPage: string | any,
      validator: Validators | any,
      greySection: boolean,
      firstSetup: boolean,
      unselectable: boolean,
      showBackgroundCircle?: boolean,
      stroke?: boolean,
      nopadding?: boolean
    }


    interface GenericInputInterface {
      logoURL: string,
      text: string,
      valuePlaceHolder: string,
      fieldName: string,
      previousPage: string,
      nextPage: string | any,
      validator: Validators | any,
      maxLength: number,
      firstSetup: boolean,
      showBackgroundCircle?: boolean,
      nopadding?: boolean
    }

    interface DefaultPageInterface {
      fieldName: string,
      previousPage: string,
      nextPage: string | any
    }

    switch (page) {

      case 'gender':
        let genderInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/gender.svg',
          text: this.translate.instant('whatIsYourGender'),
          options: [{ value: 'female', label: this.translate.instant('woman') },
          { value: 'male', label: this.translate.instant('man') },
          { value: 'other', label: this.translate.instant('nonBinaryGenderDiverse') }
          ],
          fieldName: 'gender2',
          selectMultipleAllowed: false,
          previousPage: null,
          nextPage: 'interest',
          validator: Validators.compose([Validators.required, Validators.maxLength(30), Validators.minLength(2)]),
          greySection: false,
          firstSetup: this.isFirstSetup,
          unselectable: false,
          showBackgroundCircle: true,
        };

        this.openModalsRenewed('gender', genderInfo.nextPage, genderInfo.previousPage, genderInfo, true, 'choice');
        break;

      case 'interest':

        let interestInfo: DefaultPageInterface = {
          fieldName: 'interest',
          previousPage: 'gender',
          nextPage: 'name'
        }

        this.openModalsRenewed(interestInfo.fieldName, interestInfo.nextPage, interestInfo.previousPage, null, false, '');
        break;

      case 'name':
        let nameInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/name.svg',
          text: this.translate.instant('wouldLikeToBeCalled'),
          valuePlaceHolder: this.translate.instant('yourName'),
          fieldName: 'firstName',
          previousPage: 'interest',
          nextPage: 'age',
          validator: Validators.compose([Validators.required, Validators.pattern("^(?![0-9]).*"), Validators.maxLength(50), Validators.minLength(2)]),
          maxLength: 50,
          firstSetup: this.isFirstSetup,
          showBackgroundCircle: true,
        };

        //alert(JSON.stringify(nameInfo));

        //pageName : string, nextPage : string, pastPage : string, pageInfo : any, isGeneric : boolean, genericType : string
        this.openModalsRenewed(nameInfo.fieldName, nameInfo.nextPage, nameInfo.previousPage, nameInfo, true, 'input');

        break;

      case 'age':
        let ageInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/age.svg',
          text: this.translate.instant('whatIsYourAge'),
          valuePlaceHolder: this.translate.instant('yourAge'),
          fieldName: 'age',
          previousPage: 'name',
          nextPage: 'city',
          validator: Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(2), Validators.minLength(2), Validators.min(18), Validators.max(100)]),
          maxLength: 2,
          firstSetup: this.isFirstSetup,
          showBackgroundCircle: true,
        };

        //pageName : string, nextPage : string, pastPage : string, pageInfo : any, isGeneric : boolean, genericType : string        
        this.openModalsRenewed(ageInfo.fieldName, ageInfo.nextPage, ageInfo.previousPage, ageInfo, true, 'input');
        break;

      case 'city':
        let nextPage: any = 'referralEmail';
        if (this.userData.referralUserId != '') {
          nextPage = null
        }
        let cityInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/location.svg',
          text: this.translate.instant('city'),
          valuePlaceHolder: this.translate.instant('insertCityHere'),
          fieldName: 'city',
          previousPage: 'age',
          nextPage: nextPage,
          validator: Validators.compose([Validators.required, Validators.pattern("^(?![0-9]).*"), Validators.maxLength(50), Validators.minLength(3)]), // standard without accents: ^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$
          maxLength: 50,
          firstSetup: this.isFirstSetup,
          showBackgroundCircle: true,
          nopadding: true,
        };

        this.openModalsRenewed(cityInfo.fieldName, cityInfo.nextPage, cityInfo.previousPage, cityInfo, true, 'input');
        break;

      case 'socialCauses':
        let socialCausesInfo: DefaultPageInterface = {
          fieldName: 'socialCauses',
          previousPage: 'city',
          nextPage: null
        }

        this.openModalsRenewed(socialCausesInfo.fieldName, socialCausesInfo.nextPage, socialCausesInfo.previousPage, null, false, '');
        break;

      case 'referralEmail':
        let referralEmailInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/logo.svg',
          text: this.translate.instant('referredMsg'),
          valuePlaceHolder: this.translate.instant('referralFriendEmailLabel'),
          fieldName: 'referralEmail',
          previousPage: 'city',
          nextPage: null,
          validator: Validators.compose([Validators.maxLength(50), Validators.minLength(3)]), // standard without accents: ^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$
          maxLength: 50,
          firstSetup: this.isFirstSetup
        };

        this.openModalsRenewed(referralEmailInfo.fieldName, referralEmailInfo.nextPage, referralEmailInfo.previousPage, referralEmailInfo, true, 'input');
        break;


      case 'activism':
        let activismInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/activism.svg',
          text: this.translate.instant('whatIsYourActivismLevel'),
          options: [{ value: 'activist', label: this.translate.instant('activist') },
          { value: 'someInThePast', label: this.translate.instant('someInThePast') },
          { value: 'willingToDo', label: this.translate.instant('willingToDo') },
          { value: 'lowProfile', label: this.translate.instant('lowProfile') }
          ],
          fieldName: 'activism',
          selectMultipleAllowed: false,
          previousPage: null,
          nextPage: 'work',
          validator: null,
          greySection: false,
          firstSetup: false,
          unselectable: true,
          stroke: true,
          nopadding: true,
        };

        this.openModalsRenewed(activismInfo.fieldName, activismInfo.nextPage, activismInfo.previousPage, activismInfo, true, 'choice');
        break;

      case 'work':
        let workInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/work.svg',
          text: this.translate.instant('workAs'),
          valuePlaceHolder: this.translate.instant('yourWork'),
          fieldName: 'work',
          previousPage: 'activism',
          nextPage: 'education',
          validator: Validators.compose([Validators.maxLength(50)]),
          maxLength: 50,
          firstSetup: false,
          showBackgroundCircle: true,
          nopadding: true,
        };

        this.openModalsRenewed(workInfo.fieldName, workInfo.nextPage, workInfo.previousPage, workInfo, true, 'input');
        break;

      case 'education':
        let educationInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/education.svg',
          text: this.translate.instant('whatIsYourEducation'),
          options: [
            { value: 'noFormalEducation', label: this.translate.instant('noFormalEducation') },
            { value: 'secondaryIncomplete', label: this.translate.instant('secondaryIncomplete') },
            { value: 'secondaryComplete', label: this.translate.instant('secondaryComplete') },
            { value: 'superiorIncomplete', label: this.translate.instant('superiorIncomplete') },
            { value: 'superiorComplete', label: this.translate.instant('superiorComplete') },
            { value: 'postGraduate', label: this.translate.instant('postGraduate') },
            { value: 'doctorate', label: this.translate.instant('doctorate') }
          ],
          fieldName: 'education',
          selectMultipleAllowed: false,
          previousPage: 'work',
          nextPage: 'height',
          validator: null,
          greySection: false,
          firstSetup: false,
          unselectable: true,
          nopadding: true,
        };

        this.openModalsRenewed(educationInfo.fieldName, educationInfo.nextPage, educationInfo.previousPage, educationInfo, true, 'choice');
        break;

      case 'height':
        let heightInfo: DefaultPageInterface = {
          fieldName: 'height',
          previousPage: 'education',
          nextPage: 'exercise'
        }

        this.openModalsRenewed(heightInfo.fieldName, heightInfo.nextPage, heightInfo.previousPage, null, false, '');
        break;

      case 'exercise':
        let exerciseInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/physicalExercise.svg',
          text: this.translate.instant('doYouExercise'),
          options: [{ value: 'never', label: this.translate.instant('never') },
          { value: 'always', label: this.translate.instant('always') },
          { value: 'almostNever', label: this.translate.instant('almostNever') }],
          fieldName: 'exercise',
          selectMultipleAllowed: false,
          previousPage: 'height',
          nextPage: 'lookingFor',
          validator: null,
          greySection: false,
          firstSetup: false,
          unselectable: true,
          nopadding: true,
        };

        this.openModalsRenewed(exerciseInfo.fieldName, exerciseInfo.nextPage, exerciseInfo.previousPage, exerciseInfo, true, 'choice');
        break;

      case 'lookingFor':
        let lookingForInfo: DefaultPageInterface = {
          fieldName: 'lookingFor',
          previousPage: 'exercise',
          nextPage: 'children'
        }

        this.openModalsRenewed(lookingForInfo.fieldName, lookingForInfo.nextPage, lookingForInfo.previousPage, null, false, '');

        break;

      case 'children':
        let childrenInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/children.svg',
          text: this.translate.instant('wantChildren'),
          options: [{ value: 'yes', label: this.translate.instant('yes') },
          { value: 'maybeSomeday', label: this.translate.instant('maybeSomeday') },
          { value: 'no', label: this.translate.instant('no') },
          { value: 'alreadyHave', label: this.translate.instant('alreadyHave') }],
          fieldName: 'children',
          selectMultipleAllowed: false,
          previousPage: 'lookingFor',
          nextPage: 'astroSign',
          validator: null,
          greySection: false,
          firstSetup: false,
          unselectable: true,
          nopadding: true,
        };

        this.openModalsRenewed(childrenInfo.fieldName, childrenInfo.nextPage, childrenInfo.previousPage, childrenInfo, true, 'choice');
        break;

      case 'astroSign':
        let astroSignInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/astrology.svg',
          text: this.translate.instant('whatIsYourSign'),
          valuePlaceHolder: this.translate.instant('yourSign'),
          fieldName: 'astrologySign',
          previousPage: 'children',
          nextPage: 'religion',
          validator: Validators.compose([Validators.maxLength(30)]),
          maxLength: 30,
          firstSetup: false,
          nopadding: true,
        };

        this.openModalsRenewed(astroSignInfo.fieldName, astroSignInfo.nextPage, astroSignInfo.previousPage, astroSignInfo, true, 'input')
        break;

      case 'religion':
        let religionInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/religion.svg',
          text: this.translate.instant('isReligious'),
          valuePlaceHolder: this.translate.instant('yourReligion'),
          fieldName: 'religion',
          previousPage: 'astroSign',
          nextPage: 'politics',
          validator: Validators.compose([Validators.maxLength(30)]),
          maxLength: 30,
          firstSetup: false,
          nopadding: true,
        };

        this.openModalsRenewed(religionInfo.fieldName, religionInfo.nextPage, religionInfo.previousPage, religionInfo, true, 'input');
        break;

      case 'politics':
        let politicsInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/politics.svg',
          text: this.translate.instant('isPolitical'),
          valuePlaceHolder: this.translate.instant('yourPolitics'),
          fieldName: 'politics',
          previousPage: 'religion',
          nextPage: 'pets',
          validator: Validators.compose([Validators.maxLength(30)]),
          maxLength: 30,
          firstSetup: false,
          nopadding: true,
        };

        this.openModalsRenewed(politicsInfo.fieldName, politicsInfo.nextPage, politicsInfo.previousPage, politicsInfo, true, 'input');
        break;

      case 'pets':
        let petsInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/animal_new.svg',
          text: this.translate.instant('hasPets'),
          valuePlaceHolder: this.translate.instant('yourPets'),
          fieldName: 'pets',
          previousPage: 'politics',
          nextPage: 'distanceUnits',
          validator: Validators.compose([Validators.maxLength(30)]),
          maxLength: 30,
          firstSetup: false,
          nopadding: true,
        };

        this.openModalsRenewed(petsInfo.fieldName, petsInfo.nextPage, petsInfo.previousPage, petsInfo, true, 'input');
        break;

      case 'distanceUnits':
        let distanceUnitsInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/distance.svg',
          text: this.translate.instant('distanceUnitSelection'),
          options: [{ value: 'km', label: this.translate.instant('km') },
          { value: 'mi', label: this.translate.instant('mi') }
          ],
          fieldName: 'distanceUnit',
          selectMultipleAllowed: false,
          previousPage: 'pets',
          nextPage: 'language',
          validator: null,
          greySection: true,
          firstSetup: false,
          unselectable: false,
          showBackgroundCircle: true,
        };

        this.openModalsRenewed(distanceUnitsInfo.fieldName, distanceUnitsInfo.nextPage, distanceUnitsInfo.previousPage, distanceUnitsInfo, true, 'choice');
        break;

      case 'language':
        let languageInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/language.svg',
          text: this.translate.instant('languageSelection'),
          options: [{ value: 'en', label: this.translate.instant('en') },
          { value: 'pt', label: this.translate.instant('pt') },
          { value: 'es', label: this.translate.instant('es') },
          { value: 'de', label: this.translate.instant('de') },
          { value: 'fr', label: this.translate.instant('fr') },
          { value: 'it', label: this.translate.instant('it') },
          { value: 'da', label: this.translate.instant('da') },
          { value: 'pl', label: this.translate.instant('pl') },
          { value: 'ko', label: this.translate.instant('ko') }
          ],
          fieldName: 'language',
          selectMultipleAllowed: false,
          previousPage: 'distanceUnits',
          nextPage: null,
          validator: null,
          greySection: true,
          firstSetup: false,
          unselectable: false,
          showBackgroundCircle: true,
        };

        this.openModalsRenewed(languageInfo.fieldName, languageInfo.nextPage, languageInfo.previousPage, languageInfo, true, 'choice');
        break;
    }
  }

  async openModalsRenewed(pageName: string, nextPage: string, pastPage: string | null, pageInfo: any, isGeneric: boolean, genericType: string) {

    this.setActiveFocus(false);

    console.log(pageInfo);
    //alert(JSON.stringify(pageInfo));
    //opens modal
    let modal = this.setModals(pageName, isGeneric, genericType, pageInfo);




    if (modal) {
      (await modal).onDidDismiss().then((val) => {

        if (val != null) {
          val = val.data;
          switch (pageName) {
            //modals that don't have a previous page


            case 'activism':
              this.dismissNoPreviousPage(nextPage, val);
              break;

            case 'socialCauses':
              console.log('Social causes modal dismissed, val:', val);
              if (val && typeof val === 'object' && 'data' in val) {
                // Update userData with the data from the modal
                this.userData = (val as any).data;
                console.log('Updated userData from modal:', JSON.stringify(this.userData));
              }
              const action = (val && typeof val === 'object' && 'action' in val) ? (val as any).action : val;
              this.dismissNoNextPage(pastPage, action);
              // Save the data after updating userData
              if (action === 'exitModal') {
                console.log('Calling save() from socialCauses case');
                this.save();
              }
              break;

            //modals that don't have a next page
            case 'city':
              this.dismissNoNextPage(pastPage, val);
              Preferences.set({ key: 'USER_FIRST_SETUP', value: 'true' }).then((val) => {
                console.log("userFirstSetup saved to DB");
              })

              this.save()
              break;



            case 'referralEmail':
              this.dismissNoNextPage(pastPage, val);
              Preferences.set({ key: 'USER_FIRST_SETUP', value: 'true' }).then((val) => {
                console.log("userFirstSetup saved to DB");
              })
              this.save()
              break;

            case 'language':
              this.dismissNoNextPage(pastPage, val);
              break;

            //the rest
            default:
              this.dismissDefaultPage(nextPage, pastPage, val);
              break;
          }
        } else {
          this.dismissDefaultPage(nextPage, pastPage, val);
        }

      });


    }
    this.setChanged();
    if (modal) {
      (await modal).present();
    }

  }

  interestOptions() {
    this.userData?.hasOwnProperty('interest2')
    if (this.userData != null && this.userData.hasOwnProperty('interest2')) {
      if (this.userData.interest2 != null) {
        let interestsChosen: any[] = [];

        this.userData.interest2.forEach((interest: string) => {
          if (interest == 'female') {
            interestsChosen.push(this.translate.instant('women'));
          } else if (interest == 'male') {
            interestsChosen.push(this.translate.instant('men'));
          } else if (interest == 'other') {
            interestsChosen.push(this.translate.instant('others'));
          }
        });
        // this.alertCtrl.dismiss();
        return interestsChosen.join(", ");
      } else {
        return "";
      }
    } else {
      return "";
    }

  }

  dismissNoPreviousPage(nextPage: string, data: any) {
    if (data == 'nextModal') {
      this.setPageInfo(nextPage);

    } else if (data == 'backModal' || data == 'exitModal') {
      this.setActiveFocus(true);

    } else {
      this.setActiveFocus(true);
    }
  }

  dismissNoNextPage(previousPage: string | null, data: any) {
    console.log('dismissNoNextPage called with data:', data);
    console.log('userData before save:', JSON.stringify(this.userData));

    if (data == 'backModal') {
      if (previousPage === null) {
        this.setActiveFocus(true);
      } else {
        this.setPageInfo(previousPage);
      }
    }
    else if (data == 'exitModal' || data == 'nextModal') {
      this.setActiveFocus(true);
      // Save data when modal is dismissed with exitModal
      if (data == 'exitModal') {
        console.log('Calling save() from dismissNoNextPage');
        this.save();
      }

    } else {
      this.setActiveFocus(true);
    }
  }

  dismissDefaultPage(nextPage: string, previousPage: string | null, data: any) {
    if (data == 'nextModal') {
      this.setPageInfo(nextPage);
    } else if (data == 'backModal') {
      if (previousPage === null) {
        this.setActiveFocus(true);
      } else {
        this.setPageInfo(previousPage);
      }
    } else {
      this.setActiveFocus(true);
    }
  }


  ionViewWillEnter() {
    console.log('ionViewWillEnter ProfilePage');
    let limitDate = new Date();
    let month = limitDate.getMonth() + 1;// PgetMonth is zero based
    let day = limitDate.getDate();
    this.today = limitDate.getFullYear() + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
    console.log('today: ' + this.today);

    Preferences.get({ key: 'USER_DATA' }).then(async (val: any) => {

      if (val === null) {
        this.goToLoginPage();
        return
      } else if ((JSON.parse(val.value)).needsEmailValidation) {
        this.modalCtrl.create({ component: EmailValidationPage });
        return
      }

      this.userData = val.value ? JSON.parse(val.value) : null;

      console.log(this.userData.since);
      this.userIsPremium = this.purchaseServiceProvider.isPremium(this.userData);

      this.loadView(true);
      if (this.userData) {
        this.missingInformation = this.userData.gender2 == null || this.userData.interest2 == null
          || this.userData.firstName == null || this.userData.age == null || this.userData.city == null;
      }

      if (this.isFirstSetup) {
        this.present1CoinOffer();
        //this.present5CoinPromotion();
      } else if (this.missingInformation) {
        this.alertMissingInformation();
      }
    })

  }

  async alertMissingInformation() {
    let alert = this.alertCtrl.create({
      subHeader: this.translate.instant('checkMissingInformation'),
      message: "",
      backdropDismiss: false,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            this.setPageInfo('gender');
          }
        }
      ]
    });
    (await alert).present();

  }

  goToLoginPage() {
    this.router.navigateByUrl('/login');
  }

  async present1CoinOffer() {
    let alert = this.alertCtrl.create({
      subHeader: this.translate.instant('completeProfileWinVegglyCoin'),
      message: this.translate.instant('completeProfileMsg'),
      backdropDismiss: false,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            this.setPageInfo('gender');
          }
        }
      ],
    });

    (await alert).present();
  }

  setHeight() {
    let heightValueFoot: number;
    let heightValueInch: number;

    heightValueFoot = this.userData.height * 0.0328084 | 0;  //cm -> feet
    heightValueInch = ((this.userData.height * 0.0328084) - heightValueFoot) * 12 | 0; //feet -> inches

    return ((this.userData.height / 100) + " m / " + heightValueFoot + "'" + heightValueInch);
  }


  lookingForOptions() {
    if (this.userData.lookingFor != null) {
      let optionsChosen: any[] = [];

      this.userData.lookingFor.forEach((option: string | string[]) => {
        optionsChosen.push(this.translate.instant(option));
      });

      return optionsChosen.join(", ");
    } else {
      return "";
    }
  }

  getSocialCauseDisplayText(causeId: string): string {
    return this.socialCausesService.getSocialCauseDisplayText(causeId);
  }



  // Shuffling logic

  /**
   * When an image is pressed, we start the shuffling logic
   */
  startShuffle() {
    this.shuffling = true;
    this.preShufflePictures = [...this.pictures];
    this.solveHoles(this.pictures);
  }

  async saveOrder() {
    // Reorganizar fotos para as primeiras posições antes de salvar
    this.solveHoles(this.pictures);
    this.savePicturesOnUserData(this.pictures);
    await this.saveUserData();

    this.shuffling = false;
  }

  /**
   * Move to the right all of the itens on the pictures array. Solving holes
   * @param pictures
   */
  solveHoles(pictures: String[]) {
    let availableIndex = 0
    for (let i = 0; i < pictures.length; i++) {
      if (pictures[i] === this.grayPlus) continue;

      if (i !== availableIndex) {
        pictures[availableIndex] = pictures[i];
        pictures[i] = this.grayPlus;
      }

      availableIndex++;
    }
  }

  /**
   * Check for changes on the picture list and save on the userData.
   * @param pictures 
   * @returns 
   */
  async savePicturesOnUserData(pictures: String[]) {
    // Reorganizar fotos para as primeiras posições mantendo a ordem
    this.solveHoles(pictures);

    // If no changes were made, skip
    if (pictures == this.preShufflePictures) {
      console.log("No changes on pictures order");
      return
    }

    // Save the order on the userData
    for (let i = 0; i < pictures.length; i++) {
      if (pictures[i] == this.grayPlus) {
        this.userData['picture' + i] = null;
      }
      else {
        let parts = pictures[i].split('/');
        let pic_id = parts[parts.length - 2];
        this.userData['picture' + i] = { '$oid': pic_id };
      }
    }

    // Save the userData
    Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then(async (val) => {
    }).catch(async (error) => {
      console.error('Error storing images: ', JSON.stringify(error, Object.getOwnPropertyNames(error)));
    })

  }

  async saveUserData() {
    let loader = this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
    });
    (await loader).present();

    var theObs: Observable<any>;

    Preferences.get({ key: 'LAST_LOCATION' }).then(async (val) => {
      val = val.value ? JSON.parse(val.value) : null;
      let location = val;
      let teleportationLocation = this.locationSvc.getTeleportationLocation();
      if (teleportationLocation != null) {
        location = teleportationLocation;
      }

      // Retrieve and add FCM token to userData before sending to server
      const fcmToken = await Preferences.get({ key: 'TOKEN' });
      if (fcmToken && fcmToken.value) {
        this.userData.token = fcmToken.value;
        console.log('FCM token added to userData:', fcmToken.value);
      } else {
        console.log('No FCM token found in storage');
      }

      console.log('this.userData before upsert on saveUserData: ' + JSON.stringify(this.userData));
      theObs = this.userService.upsertSoul(this.userData, location, false, true /*reorderPictures*/, false)

      theObs.subscribe({
        next: async (data) => {
          console.log('profile - upsert subscribe entered');
          console.log(JSON.stringify(data));

          if (data != '{not ok}') {
            var userData = JSON.parse(data);
            this.userData = userData;
            console.log('userData after upsert: ' + JSON.stringify(this.userData));
            Preferences.set({ key: 'USER_DATA', value: JSON.stringify(userData) }).then((val) => {
              console.log('userdata saved to DB');
            });
          }

          (await loader).dismiss();
        },
        error: async (err) => {
          this.util.showToastUnableToConnect(this.toastCtrl);
          console.log('Error: ' + JSON.stringify(err));
          //alert('Invalid email or password. Please, try again');
          (await loader).dismiss();
        }
      })
    })

  }


  private createFileName(index: number) {
    return 'picture' + index + '.jpg';
  }

  back() {
    this.showCropper = false;
  }

  private async uploadDirectlyFromBrowser(localFile: string, index: number) {
    let filename: string = 'picture' + index;
    //localFile = localFile.replace('data:image/jpeg;base64,', '');

    let loader = this.loadingCtrl.create({
      message: this.translate.instant('savingPleaseWait'),
    });
    (await loader).present();

    await this.userService.uploadImage64(localFile, this.userData, filename).subscribe(async data => {
      console.log('upload image succesful');
      console.log('data returned JSON.stringify: [' + JSON.stringify(data) + ']');
      this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
      this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
      this.userData[filename] = { '$oid': data };
      Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((val) => {
        console.log('userdata saved to DB');
      });


      let imgUrl = this.userService.getImageURL(data); //this.soulService.getBaseURL() + '/soul/image/' + aSoul[aPic].$oid; // Set the URL here as last resort
      console.log('imgUrl: ' + imgUrl);
      this.pictures[index] = imgUrl;
      this.showCropper = false;

      (await loader).dismiss();
    },
      async error => {
        (await loader).dismiss();
        this.util.showToastUnableToConnect(this.toastCtrl);
        console.log('uploadImage error: ' + JSON.stringify(error));
        this.showCropper = false;
      })

  }

  async saveCropped() {
    const loading = await this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
      spinner: 'crescent', // ou outro estilo de spinner
      duration: 5000 // tempo máximo para o loading (caso necessário)
    });
    await loading.present();


    let cropper = this.angularCropper.cropper;


    if (cropper && cropper.getCroppedCanvas()) {
      let croppedCanvas = cropper.getCroppedCanvas();

      if (croppedCanvas.width > 0 && croppedCanvas.height > 0) {
        let croppedImgB64String: string = croppedCanvas.toDataURL('image/jpeg', 1.0);
        this.croppedImage = croppedImgB64String;
        let img_base64 = this.croppedImage.split(',')[1]
        let result = await Preferences.get({ key: 'WORKING_ON_INDEX' });


        if (Boolean(result.value) == true) {
          this.workingOnIndex = parseInt(result.value?.toString() ?? '');
        }

        if (this.workingOnIndex === 0) {

          if (!this.userData?.hasValidPoseSelfie) { // if user is not validated
            // alert("!this.userData.hasValidPoseSelfie")
            this.uploadDirectlyFromBrowser(this.croppedImage, this.workingOnIndex);
            return;

          } else if (!this.userData?.userValidated) { // user validated selfies but not profile
            // alert("!this.userData?.userValidated")
            var theObs: Observable<any>;

            theObs = this.userService.updateProfilePicture(this.userData, img_base64);

            theObs.subscribe(async response => {
              // alert(data)
              let { result, pictureID } = JSON.parse(response)
              if (result === 'notok') {
                let message = this.translate.instant("photoNotValidated");
                this.showMessageAlert(this.croppedImage, this.workingOnIndex, message, false)
                return;
              } else {
                this.userData.userValidated = true;

                let imgUrl = this.userService.getImageURL(pictureID);
                this.pictures[0] = imgUrl;
                this.showComponentUserValidated();
                return;
              }
            })
            return;
          } else { // user validated selfie and profile
            // alert("this.userData?.userValidated")
            var theObs: Observable<any>;
            theObs = this.userService.updateProfilePicture(this.userData, img_base64);

            theObs.subscribe(async response => {
              let { result, pictureID } = JSON.parse(response)
              if (result === 'ok') {

                //criar novo componente. Messagem: Foto validada
                this.userData.userValidated = true;
                let imgUrl = this.userService.getImageURL(pictureID);
                this.pictures[0] = imgUrl;
                this.showComponentNewPhotoValidation();
                return;

              } else {
                this.showComponentNewPhotoNotApproved();
                //mostrar alert: Sua imagem não foi validada. Caso clique em salvar você irá perder o selo de verificação da conta
                // let message = "Sua imagem não foi validada. Caso clique em salvar você irá perder o selo de verificação da conta"
                // this.showMessageAlert(this.croppedImage, this.workingOnIndex, message, true);
                return
              }

            })

            return;
          }
        } else {
          this.uploadDirectlyFromBrowser(this.croppedImage, this.workingOnIndex);
          console.log('workingOnIndex: ' + this.workingOnIndex);
        }
      }
    } else {
      this.util.presentToast(this.toastCtrl, this.translate.instant('failUploadImage'), 5000);
      this.showCropper = false;
    }


  }


  async showComponentUserValidated() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    const modal = await this.modalCtrl.create({
      component: ValidationCompletedComponent,
      componentProps: {
        me: this.userData
      },
      cssClass: 'custom-class-modal',
      backdropDismiss: true
    });
    modal.present();

    modal.onDidDismiss().then(async (val) => {
      this.refreshPage()
    });

    await modal.onDidDismiss();
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

  }

  async showComponentNewPhotoValidation() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    const modal = await this.modalCtrl.create({
      component: NewPhotoValidationComponent,
      componentProps: {
        me: this.userData
      },
      cssClass: 'custom-class-modal',
      backdropDismiss: true
    });

    (await modal).present();

    await modal.onDidDismiss().then((val) => {
      this.refreshPage()
    });
    await modal.onDidDismiss();
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  async refreshPage() {
    Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then(async (val) => {
      console.log("userData saved")
    })
    this.showCropper = false;
    this.modalCtrl.dismiss();
  }

  async showComponentNewPhotoNotApproved() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    const modal = await this.modalCtrl.create({
      component: NewPhotoNotApprovedComponent,
      componentProps: {
        me: this.userData
      },
      cssClass: 'custom-class-modal',
      backdropDismiss: true
    });

    (await modal).onDidDismiss().then((val) => {

      if (val && val.data === "descart") {
        this.showCropper = false;
        return;
      } else if (val && val.data === "toUse") {
        this.userData.userValidated = false;
        this.uploadDirectlyFromBrowser(this.croppedImage, this.workingOnIndex);
        return;
      }

    });
    (await modal).present();
    await modal.onDidDismiss();
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';


  }

  async showMessageAlert(croppedImage: any, workingOnIndex: any, message: any, changeUserValidated?: boolean) {
    const alert = await this.alertCtrl.create({
      message: message,
      buttons: [
        {
          text: this.translate.instant('save'),
          role: 'info',
          handler: () => {
            this.uploadDirectlyFromBrowser(this.croppedImage, this.workingOnIndex);

            if (changeUserValidated) {
              this.userData.userValidated = false;
            }
            return;
          }
        },
        {
          text: this.translate.instant('cancel'),
          role: 'cancel',
          handler: () => {
            this.showCropper = false;
            return;
          }
        }
      ],

    });
    (await alert).present();
  }

  public async presentActionSheet(index: number) {

    if (this.userData?.userValidated && index === 0) {

      const toast = this.toastCtrl.create({
        message: this.translate.instant('profilePhotoValidationWarning'),
        duration: 5000,
        position: 'top'
      });

      (await toast).present();

    }

    let arrayButtons = []
    arrayButtons = [
      {
        text: this.translate.instant('selectFromGallery'),
        handler: () => {
          this.index = index;
          this.workingOnIndex = index;
          Preferences.set({ key: 'WORKING_ON_INDEX', value: JSON.stringify(index) });
          this.selectFromDevice(index);
        }
      },
      {
        text: this.translate.instant('delete'),
        role: 'destructive',
        handler: () => {
          console.log('Delete clicked');
          this.deleteFile(index);
        }
      },
      {
        text: this.translate.instant('cancel'),
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }
    ]
    let actionSheet = this.actionSheetCtrl.create({
      buttons: arrayButtons
    });
    (await actionSheet).present();

  }

  async selectFromDevice(index: number) {
    const status = await Camera.checkPermissions();
    if (status.photos === 'granted') {
      this.openGallery(index);
      return;
    }

    const newStatus = await Camera.requestPermissions();

    if (newStatus.photos === 'granted') {
      this.openGallery(index);
    } else {
      this.denyCount++;

      if (this.denyCount >= 2) {
        this.showSettingsModal();
      }
    }

  }

  async showSettingsModal() {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('permissionNecessary'),
      message: this.translate.instant('permissionGallery'),
      buttons: [
        {
          text: this.translate.instant('cancel'),
          role: 'cancel'
        },
        {
          text: this.translate.instant('settingsTitle'),
          handler: async () => {
            if (Capacitor.getPlatform() === 'ios') {
              this.openSettingsIos()
            } else {
              // No Android, abre a página de configurações do app
              this.openSettingsAndroid()
            }
          }
        }
      ]
    });

    await alert.present();
  }

  openSettingsAndroid() {
    NativeSettings.openAndroid({
      option: AndroidSettings.ApplicationDetails,
    });
  }

  openSettingsIos() {
    NativeSettings.openIOS({
      option: IOSSettings.App,
    });

  }


  openGallery(index: any) {
    this.workingOnIndex = index;
    Preferences.set({ key: 'WORKING_ON_INDEX', value: JSON.stringify(this.workingOnIndex) });

    let pictureName = 'picture' + index + '.jpg';

    let options = {
      quality: 100,
      allowEditing: false,
      resultType: CameraResultType.Uri,
      width: 1200,
      height: 1200,
      source: CameraSource.Photos,
      limit: 1
    }
    this.getImageFromDevice(index, options);
  }

  private getImageFromDevice(index: number, options: any) {
    //alert('platforms: ' + this.platform.platforms());
    console.log('platforms: ' + this.platform.platforms());
    console.log('this.isNative: ' + this.isNative);

    if (this.isNative) {
      Camera.checkPermissions().then(async (hasIt) => {
        console.log('pictures - hasReadPermission: ' + hasIt.photos);
        if (hasIt.photos != 'granted') {
          if (this.platform.is('android')) {
            console.log('pictures - is android');
            let message = this.translate.instant('pleaseAuthorizePicturesAccess');
            this.util.showModalAlertRequestPermission(message, AndroidSettings.ApplicationDetails, IOSSettings.App)
            // this.showModalAlert(this.translate.instant('pleaseAuthorizePicturesAccess'));
            await Camera.requestPermissions().then().catch((err) => {
              console.error('pictures - getImageFromDevice: ' + JSON.stringify(err));
            });
          } else {
            console.log('pictures - is NOT android');
            await Camera.requestPermissions().then((data) => {
              console.log('pictures - requestReadPermission success: ' + JSON.stringify(data));

              this.readFromDisk(options, index);
            }).catch((err) => {
              let message = this.translate.instant('pleaseAuthorizePicturesAccessOnSettings');
              this.util.showModalAlertRequestPermission(message, AndroidSettings.ApplicationDetails, IOSSettings.App)
              // this.showModalAlert(this.translate.instant('pleaseAuthorizePicturesAccessOnSettings'));

              console.error('pictures - requestReadPermission: ' + JSON.stringify(err));
            })
          }
          return;
        } else {
          this.readFromDisk(options, index);
        }
      })


    } else {
      // If it's browser, read directly
      this.readFromDisk(options, index);
    }

    //    }

  }

  private async readFromDisk(options: any, index: number) {
    let loader = this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
    });
    (await loader).present();
    try {

      await Camera.pickImages(options).then(async (results) => {
        // (await loader).present();

        console.log('pictures - results: ' + JSON.stringify(results));
        if (results == null || results.photos.length == 0) {
          console.log('pictures - results == []. Will return');
          return;
        }

        for (var i = 0; i < results.photos.length; i++) {
          let imagePath = results.photos[i].webPath;
          console.log('Image URI: ' + imagePath);

          const base64Data = await this.readAsBase64(results.photos[i] as Photo);
          this.myImage = this.sanitizer.bypassSecurityTrustUrl(base64Data);
          this.showCropper = true;
          if (loader) {
            (await loader).dismiss();
          }

          return;


        }
        console.log('pictures - after the for (results)');
        if (loader) {
          (await loader).dismiss();
        }

      }, async (err) => {
        if (loader) {
          (await loader).dismiss();
        }
        console.error('pictures - Error getting image.' + JSON.stringify(err));
      })
      if (loader) {
        (await loader).dismiss();
      }
    }
    catch (error) {
      if (loader) {
        (await loader).dismiss();
      }
      console.error('pictures - Error getting image caught: ' + JSON.stringify(error));
    }
  }

  private async readAsBase64(photo: Photo) {
    // Fetch the photo, read as a blob, then convert to base64 format
    const response = await fetch(photo.webPath!);
    const blob = await response.blob();
    return await this.convertBlobToBase64(blob) as string;
  }

  private convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any).__zone_symbol__originalInstance;
    const reader = zoneOriginalInstance || fileReader;
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });

  async showModalAlert(message: any) {
    let alert = this.alertCtrl.create({
      //title: this.translate.instant('statisticalOnly'),
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    (await alert).present();
  }


  reset() {
    this.angularCropper.cropper.reset();
  }

  clear() {
    this.angularCropper.cropper.clear();
  }

  rotate() {
    this.angularCropper.cropper.rotate(90);
  }

  zoom(zoomIn: boolean) {
    let factor = zoomIn ? 0.1 : -0.1;
    this.angularCropper.cropper.zoom(factor);
  }

  scaleX() {
    this.scaleValX = this.scaleValX * -1;
    this.angularCropper.cropper.scaleX(this.scaleValX);
  }

  scaleY() {
    this.scaleValY = this.scaleValY * -1;
    this.angularCropper.cropper.scaleY(this.scaleValY);
  }

  move(x: any, y: any) {
    this.angularCropper.cropper.move(x, y);
  }


  private deleteFile(index: number) {
    if (this.pictures[index] == PicturesPage.grayPlus) {
      return;
    }
    let theFile: string = this.createFileName(index);
    Filesystem.deleteFile({ path: theFile, directory: Directory.Data }).then(success => { }, error => { });
    this.pictures[index] = PicturesPage.grayPlus;
    this.picChanged[index] = false;

    let userId = this.userData?._id.$oid;
    console.log('userData._id.$oi: ' + userId);

    this.userService.deleteFile(userId, 'picture' + index, this.userData).subscribe(async (data) => {
      if (this.userData?.userValidated && index === 0) {
        this.userData.userValidated = false;
      }
      await this.savePicturesOnUserData(this.pictures);
      await this.validateProfile(true);
      console.log('delete image succesful');
      console.log('data returned JSON.stringify: [' + JSON.stringify(data) + ']');
      this.userData["picture" + index] = null;
      Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((val) => {
        console.log('userdata saved to DB');
      })
    }, (err) => {
      this.util.showToastUnableToConnect(this.toastCtrl);
      console.log('deleteFile error: ' + JSON.stringify(err));
    })
  }


  ionViewWillLeave() {
    this.showCropper = false;
    console.log('ionViewWillLeave called..');
    if (this.hasChanged()) {
      this.save();
    }
  }
  private hasChanged(): boolean {
    return this.changed;
  }


  async openValidation() {
    Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then(async (val) => {
      console.log('refreshed userdata stored');

      if (this.userData?.userValidated) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        let modal = this.modalCtrl.create({
          component: ProfileAlreadyValidatedComponent, cssClass: 'custom-class-modal',
          backdropDismiss: true
        });
        (await modal).present();
        (await modal).onDidDismiss();
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      } else {
        // Verifica se não é Android nem iOS (web) e perfil não validado
        if (!this.platform.is('android') && !this.platform.is('ios')) {
          this.showNotAvailableModal();
          return;
        }

        if (!this.userData?.hasValidPhone && !localStorage.getItem('skipStep') && !this.userData?.hasValidPoseSelfie) {
          this.backPage(); // se não quiser que salve:  this.modalCtrl.dismiss(); 
          this.router.navigate(['/home-check-profile'], { queryParams: { originValidation: '/tabs/my-profile-display' } });
        } else {
          if (this.userData?.hasValidPoseSelfie && !this.userData?.userValidated) {
            this.validateProfile(true);
          } else {
            this.validateProfile(false);
            this.backPage(); // se não quiser que salve:  this.modalCtrl.dismiss(); 
            this.router.navigate(['/instructions-check-profile'], { queryParams: { originValidation: '/tabs/my-profile-display' } });
          }
        }
      }
    });
  }

  async showNotAvailableModal() {
    const modal = await this.modalCtrl.create({
      component: NotAvailableComponent,
      componentProps: {
        downloadLink: environment.adjustDownloadLink
      },
      cssClass: 'custom-class-modal',
      backdropDismiss: true
    });

    await modal.present();

    modal.onDidDismiss().then(() => {
      // Usuário permanece na tela do profile
      // Não fazemos nada aqui para garantir que o usuário permaneça na tela
    });
  }

  validateProfile(verifyIsCompleted: boolean) {
    var theObs: Observable<any>;
    console.log(this.userData)
    theObs = this.userService.validateProfile(this.userData);
    theObs.subscribe(async response => {
      let data = JSON.parse(response);
      if (data.result === 'notok' && verifyIsCompleted) {
        this.userData.userValidated = false;
      } else if (data.result === 'ok') {
        this.userData.userValidated = true;
      } else {
        this.userData.userValidated = false;
      }
      await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((val) => {
        console.log('userdata saved to DB');
      })

      return;
    },
      err => {
        this.util.showToastUnableToConnect(this.toastCtrl);
        console.log('Error: ' + JSON.stringify(err));
      })
  }

  getGenderDisplayText(genderValue: string): string {
    if (!genderValue) return '';

    switch (genderValue) {
      case 'female':
        return this.translate.instant('woman');
      case 'male':
        return this.translate.instant('man');
      case 'other':
        return this.translate.instant('nonBinaryGenderDiverse');
      default:
        return genderValue; // Return as-is if it's a custom description
    }
  }

  // Métodos para lazy loading avançado
  onImageLoaded(event: { url: string, loadTime: number }): void {
    console.log(`✅ Imagem do perfil carregada em ${event.loadTime.toFixed(2)}ms:`, event.url);

    // Analytics de performance
    if (event.loadTime > 1000) {
      console.warn(`⚠️ Imagem demorou ${event.loadTime.toFixed(2)}ms para carregar:`, event.url);
    }
  }

  onImageError(event: { url: string, error: string }): void {
    console.error(`❌ Erro ao carregar imagem do perfil:`, event.url, 'Erro:', event.error);
  }

  openDietSince() {
    //document.getElementById('dietSinceDate').click();
    this.openDatePicker = !this.openDatePicker;
  }

  formatDietSince() {
    let formatedDate: string[] = ['', ''];

    let splittedDate: string[] = this.userData.since.split('-'); // [YYYY, MM, DD]

    let defaultFormat: string = this.translate.instant('dateFormat'); // Tipo 'MM/YYYY' ou 'YYYY/MM'
    let separator: string = defaultFormat.includes('/') ? '/' : '.';

    let defaultFormatSplit: string[] = defaultFormat.split(separator);

    let index = 0;
    for (let i = 0; i < defaultFormatSplit.length; i++) {
      switch (defaultFormatSplit[i]) {
        case 'YYYY':
          formatedDate[index++] = splittedDate[0];
          break;
        case 'MM':
        case 'MMM': // Se precisar tratar mês abreviado também
          formatedDate[index++] = splittedDate[1];
          break;
        // Ignora dia (DD ou DDD)
      }
    }

    return formatedDate.join(separator);
  }

  dateSelected(e: any) {
    this.setChanged();
    try {
      e = new Date(e.detail.value);
      let aux = e.toISOString().slice(0, 10);
      aux = aux.slice(0, -2) + "01";

      e = new Date(aux);
      this.dietSinceDate = e;
      this.userData.since = String(aux);
    } catch {
      let aux: any = Date.now();
      e = new Date(aux)
      aux = e.toISOString().slice(0, 10);
      aux = aux.slice(0, -2) + "01";
      this.dietSinceDate = e;
      this.userData.since = String(aux);
    }

    this.openDatePicker = false;
  }

  saveDietSinceDate() {
    this.setChanged();
    this.userData.since = this.dietSinceDate;
  }

}